<template>
    <div>
        <div :class="isMobile?'contBoxB':'contBox'">
           <div class="clearfix">
            <span class="fl mr5" :class="isMobile?'ml10':''">当前位置:</span>
            <el-breadcrumb class="fl" style="margin-top: 4px;font-size: 15px;" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>行业自律</el-breadcrumb-item>
            </el-breadcrumb>
           </div>
           <div :class="isMobile?'partyBoxB':'partyBox'">
                <div class="partyData" v-if="partyList.length!=0">
                    <div class="clearfix partyList" v-for="(item,index) in partyList" :key="index" @click="lookInfo(item.NewsGuid)">
                        <template v-if="!isMobile">
                            <span class="fl point"></span>
                            <span class="fl overh partyT">{{item.Title}}</span>
                            <span class="fr partime">{{item.AddTime | timeToDate}}</span>
                        </template>
                        <template v-else>
                            <div class="clearfix">
                                <span class="fl point"></span>
                                <span class="fl overh partyTB">{{item.Title}}</span>
                            </div>
                            <p class="partime mt10 textr">{{item.AddTime | timeToDate}}</p>
                        </template>
                    </div>
                </div>
                <el-empty v-if="partyList.length==0" description="暂无数据"></el-empty>
                <el-pagination v-if="partyList.length!=0" class="textc mt10" background layout="prev, pager, next" :total="total" @current-change="handelPage" :pager-count="5"></el-pagination>
           </div>
        </div>
    </div>
</template>

<script>
    export default{
        data(){
            return{
                partyList:[],
                total:20,
                form:{
                    cataCode:103101,
                    pageIndex:1,
                    pageSize:10
                }
            }
        },
        methods:{
            //获取列表数据
              getListData(){
                this.Request({
                    url: '/api/NewsData/GetNewsDataTwo',
                    method: 'get',
                    data:{
                        ...this.form
                    }
                }).then((data) => {
                   this.total = data.TotalSum
                   this.partyList = data.Data
                })
            },

            //查看详情
            lookInfo(id){
                this.$router.push({
                    path:'/industrySelf/info?id='+id
                })
            },

            //切换分页
            handelPage(val){
                this.form.pageIndex = val
                this.getListData()
            }
        },
        mounted(){
            this.getListData()
        }
    }
</script>

<style scoped>
  
</style>